import {
  LOADING_TOGGLE_ACTION,
  LOGIN_CONFIRMED_ACTION,
  LOGIN_FAILED_ACTION,
  LOGOUT_ACTION,
  SIGNUP_CONFIRMED_ACTION,
  SIGNUP_FAILED_ACTION,
  SET_COUNTRY,
} from "../actions/AuthActions";

const storedUser = localStorage.getItem("userDetails")
  ? JSON.parse(localStorage.getItem("userDetails"))
  : {
    name: "",
    role: "",
    email: "",
    idToken: "",
    localId: null,
    expiresIn: "",
    refreshToken: "",
  };


const initialState = {
  auth: storedUser,
  country_id: 1,
  country_name: "Germany",
  errorMessage: "",
  successMessage: "",
  showLoading: false,
};

export function AuthReducer(state = initialState, action) {
  switch (action.type) {
    case SIGNUP_CONFIRMED_ACTION:
      return {
        ...state,
        auth: action.payload,
        errorMessage: "",
        successMessage: "Signup Successfully Completed",
        showLoading: false,
      };

    case LOGIN_CONFIRMED_ACTION:
      return {
        ...state,
        auth: action.payload,
        errorMessage: "",
        successMessage: "Login Successfully Completed",
        showLoading: false,
      };

    case LOGOUT_ACTION:
      return {
        ...state,
        auth: {
          name: "",
          role: "",
          email: "",
          idToken: "",
          localId: "",
          expiresIn: "",
          refreshToken: "",
        },
        country_id: 1,
        country_name: "Germany",
        errorMessage: "",
        successMessage: "",
      };

    case SET_COUNTRY:
      return {
        ...state,
        country_id: action.payload.country_id,
        country_name: action.payload.country_name,
      };

    case LOGIN_FAILED_ACTION:
    case SIGNUP_FAILED_ACTION:
      return {
        ...state,
        errorMessage: action.payload,
        successMessage: "",
        showLoading: false,
      };

    case LOADING_TOGGLE_ACTION:
      return {
        ...state,
        showLoading: action.payload,
      };

    default:
      return state;
  }
}
